import { Row } from 'antd';

import { useParams } from 'react-router-dom';

import QaSpecProcessStage from './QaSpecProcessStage';
import QaSpecDocument from './QaSpecDocument';

import { useTabExpand } from 'hooks/useTabExpandProduct';

import { useManufacturingStageData } from './hooks';

const QaSpecManufacturingProcess = ({ productEnums }) => {
  const { tableStyle } = useTabExpand();

  const { id: productId } = useParams();

  const manufacturingStageQuery = useManufacturingStageData(productId);

  return (
    <Row style={{ padding: '0 6px' }}>
      <QaSpecProcessStage
        tableStyle={tableStyle}
        productEnums={productEnums}
        manufacturingStageQuery={manufacturingStageQuery}
        productId={productId}
      />
      <QaSpecDocument tableStyle={tableStyle} />
    </Row>
  );
};

export default QaSpecManufacturingProcess;
